"use client";


import { CarouselComponent } from "@/blocks/Carousel/Carousel";
// import { useResponsive } from "@/client/hooks/useResponsive";
import React, { useMemo } from "react";

// const CarouselComponent = dynamic(()=> import("@/blocks/Carousel/Carousel"));

export default function CarouselWrapper(props: {title?: string, id:string, autoplay?: boolean, autoscroll?: boolean, description?: any, children: React.ReactNode, animated?: boolean, animationType?: string, slidesToShow?: number, slidesToScroll?: number, autoplaySpeed?: number, speed?: number, transitionType?: string, centerMode?:boolean, showButtons?: boolean, showPaging?: boolean, infinite?:boolean, pauseOnHover?:boolean, swipeToSlide?: boolean, draggable?: boolean, variableWidth?: boolean}) {
  const { title, description, id, autoplay, animated, animationType, autoscroll, slidesToShow, slidesToScroll, autoplaySpeed, speed, transitionType, centerMode } = props;

  const isInFrame = (typeof window !== "undefined") && window.self !== window.top;

  const propsSettings = {
    id:id,
    subtitle:title,
    description:description,
    animated:animated,
    animation:animationType,
    autoplay:autoplay,
    autoScroll:autoscroll,
    slidesToShow :slidesToShow,
    slidesToScroll :slidesToScroll,
    autoplaySpeed :autoplaySpeed,
    speed :speed,
    transitionType:transitionType,
    centerMode:centerMode, 
    showPaging: props?.showPaging, 
    showButtons: props?.showButtons,
    infinite: props?.infinite,
    pauseOnHover: props?.pauseOnHover,
    swipeToSlide: props?.swipeToSlide,
    draggable: props?.draggable, 
    variableWidth: props?.variableWidth
  };
  

  return (
    <CarouselComponent
      {...propsSettings}
    >
      {isInFrame ? <div className="w-[800px]">
        {props.children}
      </div> : props.children}
    </CarouselComponent>
  );
}